import * as tokens from '../../../../../tokens/color.light.generated.js';
export const globalColorLight = {
    color: {
        action: {
            toggleButton: {
                indicator: {
                    default: tokens.CMP_COLOR_ACTION_TOGGLE_BUTTON_INDICATOR_DEFAULT_LIGHT
                }
            }
        },
        typography: {
            copy: {
                default: tokens.GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_LIGHT
            },
            headline: {
                default: tokens.GLOBAL_COLOR_TYPOGRAPHY_HEADLINE_DEFAULT_LIGHT,
                order1: tokens.GLOBAL_COLOR_TYPOGRAPHY_HEADLINE_ORDER1_LIGHT
            },
            display: {
                default: tokens.GLOBAL_COLOR_TYPOGRAPHY_DISPLAY_DEFAULT_LIGHT
            }
        },
        elevation: {
            level1: tokens.GLOBAL_COLOR_ELEVATION_LEVEL1_LIGHT,
            level2: tokens.GLOBAL_COLOR_ELEVATION_LEVEL2_LIGHT,
            level3: tokens.GLOBAL_COLOR_ELEVATION_LEVEL3_LIGHT,
            level4: tokens.GLOBAL_COLOR_ELEVATION_LEVEL4_LIGHT
        },
        canvas: {
            default: tokens.GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
            inverted: tokens.GLOBAL_COLOR_CANVAS_INVERTED_LIGHT
        }
    }
};
//# sourceMappingURL=color.light.js.map